/**
 * Luxistt brand copy — affordable short-stay accommodation in Nigeria & beyond.
 * Tagline: "Home, where your heart is"
 */

export const BRAND_NAME = 'Luxistt';

/** Primary tagline (include straight quotes as brand uses them) */
export const TAGLINE = 'Home, where your heart is';

/** One-line mission for meta / footers */
export const BRAND_TAGLINE_SHORT = `${BRAND_NAME} — ${TAGLINE}`;

/** Longer positioning statement */
export const BRAND_MISSION =
  'Luxistt provides "Home, where your heart is" — affordable, comfortable short-stay accommodation for guests in Nigeria and beyond. We bring together furnished Luxistt apartments, clear pricing, and simple online booking so you can settle in quickly and feel at home away from home.';

/** Home hero */
export const HERO_EYEBROW = TAGLINE;
export const HERO_HEADLINE = 'Short stays that feel like home';
export const HERO_DESCRIPTION =
  'Furnished Luxistt apartments at fair nightly rates — book online in minutes, pay safely, and stay somewhere that works for work trips, family visits, or a well-earned break, wherever your journey takes you.';
export const HERO_CTA_LABEL = 'Browse Apartments';

/** About section (home page) */
export const ABOUT_TITLE = `About ${BRAND_NAME}`;
export const ABOUT_BODY =
  `${BRAND_NAME} exists to make quality short-stay accommodation accessible. You’ll find Luxistt apartments held to a consistent standard — transparent pricing, honest photos, and a team ready when you need help. Whether you are travelling within Nigeria or visiting from abroad, we’re here to make your stay comfortable and straightforward.`;

/** Footer “More about us” blurb */
export const FOOTER_ABOUT_BLURB =
  `${BRAND_NAME} — ${TAGLINE}. Affordable short-let stays with hospitality built for real life. Book online and stay somewhere that feels like home.`;

/** Apartments / rooms page */
export const ROOMS_INTRO =
  'Browse Luxistt apartments by city, dates, and budget — from weekend breaks to longer visits — and book your stay in a few clicks.';

/** Contact page */
export const CONTACT_INTRO =
  'Questions about a stay, a booking, or working with Luxistt? Send a message — our team will respond as soon as we can.';
